'use client';

import { createClient } from '@/lib/supabase/client';
import { useEffect, useState } from 'react';

type SiteSettings = {
    id: number;
    site_name: string;
    primary_color: string;
    secondary_color: string;
    contact_email: string;
    contact_phone: string;
    radio_url?: string;
    is_radio_enabled?: boolean;
    facebook_url?: string;
    whatsapp_url?: string;
    instagram_url?: string;
    tiktok_url?: string;
    snapchat_url?: string;
};

export function SiteSettingsProvider({ children }: { children: React.ReactNode }) {
    const [settings, setSettings] = useState<SiteSettings | null>(null);
    const supabase = createClient();

    useEffect(() => {
        async function fetchSettings() {
            const { data, error } = await supabase
                .from('site_settings')
                .select('*')
                .single();

            if (data) {
                setSettings(data);
                // Apply colors to CSS custom properties
                document.documentElement.style.setProperty('--dynamic-primary', data.primary_color);
                document.documentElement.style.setProperty('--dynamic-secondary', data.secondary_color);
            }
        }

        fetchSettings();
    }, []);

    return <>{children}</>;
}
